// client/extensions/Heading.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { mergeAttributes } from "@tiptap/core";
import TiptapHeading from "@tiptap/extension-heading";
var HeadingTranslations = {
  heading: {
    heading1: ["\xDCberschrift 1", "Heading 1"],
    heading2: ["\xDCberschrift 2", "Heading 2"],
    heading3: ["\xDCberschrift 3", "Heading 3"],
    heading4: ["\xDCberschrift 4", "Heading 4"]
  }
};
var Heading = {
  styles: ({ host }) => [
    {
      [`${DesignSystem.prefix}-h2`]: { marginBlockStart: "0.83em", marginBlockEnd: "0.83em" },
      [`${DesignSystem.prefix}-h3`]: { marginBlockStart: "1em", marginBlockEnd: "1em" },
      [`${DesignSystem.prefix}-h4`]: { marginBlockStart: "1.33em", marginBlockEnd: "1.33em" }
    }
  ],
  buttons: ({ editor, host }) => [
    {
      name: "toggleHeading1",
      dropdownText: host.translator.translate("tiptap", "heading", "heading1"),
      icon: "format_h1",
      action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      tooltip: host.translator.translate("tiptap", "heading", "heading1")
    },
    {
      name: "toggleHeading2",
      dropdownText: host.translator.translate("tiptap", "heading", "heading2"),
      icon: "format_h2",
      action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      tooltip: host.translator.translate("tiptap", "heading", "heading2")
    },
    {
      name: "toggleHeading3",
      dropdownText: host.translator.translate("tiptap", "heading", "heading3"),
      icon: "format_h3",
      action: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
      tooltip: host.translator.translate("tiptap", "heading", "heading3")
    },
    {
      name: "toggleHeading3",
      dropdownText: host.translator.translate("tiptap", "heading", "heading4"),
      icon: "format_h4",
      action: () => editor.chain().focus().toggleHeading({ level: 4 }).run(),
      tooltip: host.translator.translate("tiptap", "heading", "heading4")
    }
  ],
  extensions: [
    TiptapHeading.configure({ levels: [1, 2, 3, 4] }).extend({
      renderHTML({ node, HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel ? node.attrs.level : 2;
        return [`${DesignSystem.prefix}-h${level}`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
      },
      parseHTML() {
        const cases = [];
        for (const level of this.options.levels) {
          cases.push({ tag: `h${level}`, attrs: { level } });
          cases.push({ tag: `${DesignSystem.prefix}-h${level}`, attrs: { level } });
          if (DesignSystem.prefix !== "x")
            cases.push({ tag: `x-h${level}`, attrs: { level } });
        }
        return cases;
      }
    })
  ]
};
export {
  Heading,
  HeadingTranslations
};
